/**
 * O código do curso, que é o que cabe ao lado do nome.
 *
 * O SAGA manda a string inteira — "PPAP001 - Piloto Privado - Avião -
 * Prático". Numa linha de identificação isso ocupa tudo e empurra o resto para
 * fora; o código sozinho já diz a mesma coisa para quem trabalha com ele, e a
 * string inteira fica no `title` do elemento.
 *
 * Mesma regra do servidor (`painel/identidade.ts`), repetida aqui porque o
 * painel não importa do backend — são dois pacotes. A regra é de uma linha e
 * os dois lados têm teste.
 */
export function codigoDoCurso(curso: string | null): string | null {
  if (!curso) return null;
  const codigo = curso.split(/\s+-\s+/)[0]?.trim();
  return codigo ? codigo : curso;
}
